import "../../../../index78.css";
import { jsxs as s, Fragment as g, jsx as e } from "react/jsx-runtime";
import { i as b } from "../../../../type-BFTbooL7.js";
import { _ as M } from "../../../../cs-piwRuCFZ.js";
import n from "../../../TextOutput/index.js";
import N from "../../../Tooltip/index.js";
import { C as m } from "../../../../common-UUpiO33D.js";
const q = "_multi-timeline-item_14iaq_1", B = "_timeline-progress-bar_14iaq_8", P = "_highlighted-timeline-progress-bar_14iaq_17", w = "_today-marker_14iaq_26", $ = "_start-date-marker_14iaq_32", x = "_end-date-marker_14iaq_39", a = {
  multiTimelineItem: q,
  timelineProgressBar: B,
  highlightedTimelineProgressBar: P,
  todayMarker: w,
  startDateMarker: $,
  endDateMarker: x
};
function O(h) {
  const {
    className: c,
    startDate: d,
    endDate: o,
    dateRange: t,
    highlightedStartDate: r,
    highlightedEndDate: l,
    startDateLabel: T,
    endDateLabel: u,
    highlightedStartDateLabel: D,
    highlightedEndDateLabel: _
  } = h;
  if (b(t) || !m(d) || !m(o) || !m(r) || !m(l))
    return null;
  const i = t.end.getTime() - t.start.getTime(), p = 1 - (t.end.getTime() - new Date(d).getTime()) / i, f = (t.end.getTime() - new Date(o).getTime()) / i, v = 1 - (t.end.getTime() - (/* @__PURE__ */ new Date()).getTime()) / i, y = 1 - (t.end.getTime() - new Date(r).getTime()) / i, k = (t.end.getTime() - new Date(l).getTime()) / i;
  return /* @__PURE__ */ s(g, { children: [
    /* @__PURE__ */ s("div", { className: M(a.multiTimelineItem, c), children: [
      /* @__PURE__ */ e("div", { className: a.startDateMarker }),
      /* @__PURE__ */ e("div", { className: a.endDateMarker }),
      /* @__PURE__ */ e(
        "div",
        {
          className: a.todayMarker,
          style: {
            left: `${100 * v}%`
          }
        }
      ),
      /* @__PURE__ */ e(
        "div",
        {
          className: a.timelineProgressBar,
          style: {
            left: `${100 * p}%`,
            right: `${100 * f}%`
          }
        }
      ),
      /* @__PURE__ */ e(
        "div",
        {
          className: a.highlightedTimelineProgressBar,
          style: {
            left: `${100 * y}%`,
            right: `${100 * k}%`
          }
        }
      )
    ] }),
    /* @__PURE__ */ e(
      N,
      {
        description: /* @__PURE__ */ s(g, { children: [
          /* @__PURE__ */ e(
            n,
            {
              valueType: "date",
              label: T,
              value: d
            }
          ),
          /* @__PURE__ */ e(
            n,
            {
              label: u,
              value: o,
              valueType: "date"
            }
          ),
          r && l && /* @__PURE__ */ s(g, { children: [
            /* @__PURE__ */ e(
              n,
              {
                label: D,
                value: r,
                valueType: "date"
              }
            ),
            /* @__PURE__ */ e(
              n,
              {
                label: _,
                value: l,
                valueType: "date"
              }
            )
          ] })
        ] })
      }
    )
  ] });
}
export {
  O as default
};
